import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpLeft } from 'lucide-react';
const projects = [{
  id: 1,
  title: 'אפליקציית פינטק',
  category: 'עיצוב UX/UI',
  gradient: 'from-[#7c5cfc] to-[#22d3ee]'
}, {
  id: 2,
  title: 'פלטפורמת מסחר',
  category: 'פיתוח Web',
  gradient: 'from-[#ff2d8a] to-[#7c5cfc]'
}, {
  id: 3,
  title: 'דאשבורד AI',
  category: 'עיצוב מוצר',
  gradient: 'from-[#22d3ee] to-[#10b981]'
}, {
  id: 4,
  title: 'ארנק קריפטו',
  category: 'אפליקציית מובייל',
  gradient: 'from-[#f59e0b] to-[#ef4444]'
}, {
  id: 5,
  title: 'פורטל נדל"ן',
  category: 'פיתוח Web',
  gradient: 'from-[#6366f1] to-[#a855f7]'
}, {
  id: 6,
  title: 'אפליקציית כושר',
  category: 'עיצוב UX/UI',
  gradient: 'from-[#ec4899] to-[#f43f5e]'
}];
export function Work() {
  return <section id="work" className="py-32 relative z-20" data-id="element-165">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-166">
        <motion.div className="mb-20" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-167">
          <h2 className="text-5xl md:text-7xl font-display font-black text-white mb-6" data-id="element-168">
            עבודות <span className="text-gradient" data-id="element-169">נבחרות</span>
          </h2>
          <p className="text-xl text-white/60 max-w-2xl" data-id="element-170">
            הצצה לחלק מהפרויקטים המובילים שלנו. כל פרויקט הוא סיפור של חדשנות,
            עיצוב מוקפד וטכנולוגיה מתקדמת.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-171">
          {projects.map((project, index) => <motion.div key={project.id} className="group relative cursor-pointer" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.1
        }} data-id="element-172">
              <div className="relative aspect-[4/3] rounded-3xl overflow-hidden mb-6" data-id="element-173">
                {/* Placeholder for project image using gradient */}
                <div className={`absolute inset-0 bg-gradient-to-br ${project.gradient} opacity-80 group-hover:scale-105 transition-transform duration-700 ease-out`} data-id="element-174" />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center backdrop-blur-sm" data-id="element-175">
                  <div className="flex items-center gap-2 bg-white text-black px-6 py-3 rounded-full font-bold transform translate-y-4 group-hover:translate-y-0 transition-all duration-500" data-id="element-176">
                    צפה בפרויקט <ArrowUpLeft size={18} data-id="element-177" />
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-start" data-id="element-178">
                <div data-id="element-179">
                  <h3 className="text-2xl font-display font-bold text-white mb-2" data-id="element-180">
                    {project.title}
                  </h3>
                  <p className="text-white/50" data-id="element-181">{project.category}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}